import {Component, OnInit} from '@angular/core';
import * as _ from 'lodash';
import {User} from '../_models';
import {Image} from '../_models/image';
import {CloverCategories} from '../_models/cloverCategories';
import {Item} from '../_models/Item';
import {AlertService, AuthenticationService, UserService} from '../_services';
import {ActivatedRoute, Router} from '@angular/router';
import {ServerRequestService} from '../_services/serverRequest.service';
import {ImageService} from '../_services/image.service';
import {NotifierService} from 'angular-notifier';
import {AESEncryptDecryptService} from '../_services/aesencrypt-decrypt.service';
import {QrDeviceService} from '../_services/qrDevice.service';
import {QRModel} from '../_models/qrDevice';
import {TakePayment} from '../_models/takePayment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Constants} from '../constants/constants';
import { Location } from '@angular/common';
import {UtilsService} from '../_services/utils.service';
import {PartnerReauthService} from '../_services/partner-reauth.service';
import {Capacitor} from '@capacitor/core';
import {Preferences} from '@capacitor/preferences';

@Component({
  selector: 'app-clover-auth-router',
  templateUrl: './clover-auth-router.component.html',
  styleUrls: ['./clover-auth-router.component.css']
})
export class CloverAuthRouterComponent implements OnInit {

  currentUser: User;
  // categories: Category[] = [];
  images: Image[] = [];
  loading = true;
  tableUuid: string;
  serverButtonDisabled = true;
  tableName: string;
  url_merchant_id: string;
  localMerchantId: any;
  storedMerchantId: string;
  storedCloverToken: string;
  categoriesFirstMerchants: string[];
  categoriesFirstSwitch: boolean;
  cloverCategories: CloverCategories[] = [];
  cloverItems: Item[] = [];
  url_client_id: string;
  url_code: string;
  qrDevice: User;
  categoryUuid: string;
  selectedRole: string;
  loadingButton = false;
  private qrUsername: string;
  private isQrLogin: boolean;
  private orderId: string;
  private playlist: any[];
  private website = false;
  private userInReq: User;

  constructor(private alertService: AlertService, private activatedRoute: ActivatedRoute,
              private serverRequestService: ServerRequestService,
              private imageService: ImageService,
              private userService: UserService,
              private _AESEncryptDecryptService: AESEncryptDecryptService,
              private router: Router,
              private location: Location,
              private authenticationService: AuthenticationService,
              private deviceService: DeviceDetectorService,
              private qrService: QrDeviceService,
              private notifier: NotifierService, private utilsService: UtilsService) {
      this.currentUser = utilsService.getCurrentUser();
      this.selectedRole = this.currentUser?.selectedRole;
  }

  ngOnInit() {

    // Clear the inflight re-auth flag so a future partner 401 can trigger
    // another redirect. We landed here because the OAuth handshake just
    // completed (or is about to via cloverLogin below) — the previous bad
    // token is gone, the flag has served its purpose.
    PartnerReauthService.clearInflight();

    const url_string = window.location.href;
    const url = new URL(url_string);

    this.routerPropertiesSetup();
    if (this.isQrLogin) {
      this.qrService.getByUsername(this.qrUsername).subscribe((qrUser: QRModel) => {
          if (!qrUser) {
            // Defensive: backend returned an empty body. Strand-proof the
            // customer with a clear message instead of throwing inside the
            // subscribe callback (which would abort the forward navigation
            // and leave them on the bare /cloverAuth/cloverAuth screen).
            this.showNotification('error', 'This payment device is not set up yet. Please ask a staff member for help.');
            this.router.navigate([''], {queryParamsHandling: 'preserve'});
            return;
          }
          // Order-only QR devices (e.g. a kiosk later enabled for
          // scan-to-pay) can have no takePayment sub-document persisted.
          // Reading takePayment.* off undefined threw an uncaught
          // TypeError here, which killed the forward navigation and
          // stranded the customer on the bare /cloverAuth/cloverAuth
          // screen (the query params were already stripped by
          // deleteQueryParameterFromCurrentRoute). Normalize to a
          // well-formed TakePayment so both this router AND the downstream
          // payment screen (which reads takePayment.paymentRequired) keep
          // working. Scan-to-pay rendering itself is driven by the
          // lineItemStatus route param, not these flags.
          const takePayment = qrUser.takePayment || new TakePayment();
          this.qrDevice = new User();
          this.qrDevice.takePayment = takePayment;
          this.qrDevice.merchantId = qrUser.merchantId;
          this.qrDevice.orgUuid = qrUser.orgUuid;
          this.qrDevice.excludedCategories = qrUser.excludedCategories;
          this.qrDevice.firstName = 'QR ';
          this.qrDevice.token = qrUser.token;
          this.qrDevice.orgSettings = qrUser.orgSettings;
          this.qrDevice.role = [qrUser.role ? qrUser.role : Constants.QR_ORDER];
          this.selectedRole = qrUser.role ? qrUser.role : Constants.QR_ORDER;
          this.qrDevice.takePayment.devicePaymentEnabled = takePayment.devicePaymentEnabled;
          this.qrDevice.takePayment.scanToPayPayment = takePayment.scanToPayPayment;
          this.qrDevice.takePayment.cloverConnectorPayment = takePayment.cloverConnectorPayment;
          if (this.website) {
            this.qrDevice.role = [Constants.WEBSITE];
            this.selectedRole = Constants.WEBSITE;
            this.qrDevice.takePayment.devicePaymentEnabled = true;
            this.qrDevice.takePayment.scanToPayPayment = false;
            this.qrDevice.takePayment.cloverConnectorPayment = false;
            this.qrDevice.firstName =  'Website Order ';
            this.qrDevice.takePayment.creditCardPayment = true;
          }
          sessionStorage.setItem('currentUser', this._AESEncryptDecryptService.encrypt(JSON.stringify(this.qrDevice)));
          sessionStorage.setItem('selectedRole', this._AESEncryptDecryptService.encrypt(this.selectedRole));
          sessionStorage.setItem('', ' ');
          this.authenticationService.setUser(this.qrDevice);

          if (this.orderId) {
            this.currentUser = this.qrDevice;
            this.scanToPayRouter(this.orderId, this.currentUser).then(r => r);
            return;
          } else if (this.playlist) {
            this.currentUser = this.qrDevice;
            this.scanToJukeboxPay(this.playlist, this.currentUser).then(r => r);
          } else if (this.website) {
            console.log('Welcome to our website');
            this.router.navigate(['/order']).then(() => {
              window.location.reload();
            });
          } else {
            this.router.navigate(['/kiosk']).then(() => {
                window.location.reload();
            });
          }
          return;
        },
      error => {
        // The QR device lookup failed (device not found, or a network /
        // backend error). Throwing here left the customer stuck on a blank
        // /cloverAuth/cloverAuth screen with no way forward. Surface the
        // problem and route them home instead.
        console.error(error);
        this.showNotification('error', 'We could not load this payment device. Please ask a staff member for help.');
        this.router.navigate([''], {queryParamsHandling: 'preserve'});
      });
    } else if (this.userInReq) {
      this.processLoggedInUrlUser(url);
    } else if (this.url_merchant_id && this.url_client_id && this.url_code) {
      // Fresh Clover OAuth params always win over any cached user. Without this,
      // onboarding a second account (or any re-auth) while another account is
      // still in localStorage would skip /cloverApi/authenticate entirely and
      // route on stale state — which manifested as a blank blue serverOrder
      // page and the wrong account name in the header.
      this.performCloverAuthentication();
    } else if (this.currentUser && !_.isNil(this.currentUser?.username) && this.currentUser?.hasCreds) {
      this.activatedRoute.params.subscribe(params => {
          this.tableUuid = params['tableUuid'] ? params['tableUuid'] : this.currentUser.username;
          this.tableName = params['tableName'] ? params['tableName'] : this.currentUser.username;
        },
        error => {
          this.alertService.error(error);
        });
      this.categoriesFirstMerchants = ['invalid id'];
      this.categoriesFirstSwitch = true;
      this.routeToProperComponent();
    } else {
      this.router.navigate([''], {queryParamsHandling: 'preserve'});
    }
  }

  private routerPropertiesSetup() {
    const url_string = window.location.href;
    const url = new URL(url_string);

    if (url.searchParams.get('qr')) {
      this.isQrLogin = true;
      this.qrUsername = this._AESEncryptDecryptService.decrypt(url.searchParams.get('qr'));
    }
    if (url.searchParams.get('orderId')) {
      this.orderId = url.searchParams.get('orderId');
    }
    if (url.searchParams.get('playlist')) {
      this.playlist = JSON.parse(url.searchParams.get('playlist'));
    }
    if (url.searchParams.get('website')) {
      this.website = JSON.parse(url.searchParams.get('website'));
    }
    if (url.searchParams.get('onlineMenuId')) {
      sessionStorage.setItem('onlineMenuId', url.searchParams.get('onlineMenuId'));
    }
    // if (url.searchParams.get('user')) {
    //   this.userInReq = JSON.parse(url.searchParams.get('user'));
    // }
    if (url.searchParams.get('merchant_id')) {
      this.url_merchant_id = url.searchParams.get('merchant_id');
    }
    if (url.searchParams.get('code')) {
      this.url_code = url.searchParams.get('code');
    }
    if (url.searchParams.get('client_id')) {
      this.url_client_id = url.searchParams.get('client_id');
    }

    // OAuth state nonce verification. Re-auth from the profile page sets
    // localStorage.cloverOauthState to a uuidv4 before redirecting to
    // Clover. The callback must echo it back. If the values don't match
    // (or storage was cleared), refuse the callback rather than completing
    // a Clover handshake the user may not have initiated. The first-time
    // "Sign in with Clover" button does NOT set the nonce, so absence on
    // the callback is acceptable only when there's also nothing in
    // localStorage to compare against.
    try {
      const expectedState = localStorage.getItem('cloverOauthState');
      const callbackState = url.searchParams.get('state');
      if (expectedState) {
        // Clear immediately — single-use nonce.
        localStorage.removeItem('cloverOauthState');
        if (!callbackState || callbackState !== expectedState) {
          console.error('[CLOVER OAUTH] state mismatch; aborting callback');
          // Throw out the merchant/code params so we don't proceed with the
          // authentication call. The downstream branches will route to /.
          this.url_merchant_id = undefined;
          this.url_code = undefined;
          this.url_client_id = undefined;
        }
      }
    } catch (e) { /* localStorage unavailable — fall through */ }

    this.deleteQueryParameterFromCurrentRoute();

    return url;
  }

  processLoggedInUrlUser(url) {
    // if (this.userInReq) {
    //   this.currentUser = JSON.parse(this._AESEncryptDecryptService.decrypt(this.userInReq));
    //   if (this.currentUser) {
    //     localStorage.setItem(Constants.CURRENT_USER, JSON.stringify(this.userInReq));
    //     this.routeToProperComponent();
    //   }
    // }
  }

  performCloverAuthentication() {
      // Snapshot of the logged-in user BEFORE the OAuth round-trip. When this
      // exists with a token, we're on the "Re-authenticate Clover" flow off
      // the profile page — the backend now returns a minimal {ok, orgSettings,
      // merchantId} shape and we must preserve the caller's identity. When it
      // doesn't exist, we're on the unauthenticated "Sign in with Clover"
      // landing button — the backend mints a fresh JWT and returns the full
      // user payload, which we adopt as the new session.
      const preReauthUser = this.currentUser;
      const isReauth = !!(preReauthUser && preReauthUser.token && preReauthUser._id);

      this.authenticationService.cloverLogin(this.url_merchant_id, this.url_client_id, this.url_code)
        .subscribe(
          data => {
            if (!data) {
              this.router.navigate([''], {queryParamsHandling: 'preserve'});
              return;
            }
            if (isReauth) {
              // Re-auth path: do NOT overwrite identity. Older bug — when the
              // backend returned a full user record matched on merchantId, the
              // frontend used to do `this.currentUser = data` and the UI
              // suddenly showed a different Admin's name (e.g. the original
              // Clover-owner-registered user). Now we merge only orgSettings
              // and leave id/firstName/lastName/role/token/username untouched.
              if (data._id && data._id !== preReauthUser._id) {
                // Backend regression / tampering — refuse to consume an
                // identity-bearing payload on the re-auth path. Force the
                // user back to sign-in rather than silently swap them.
                console.error('[CLOVER REAUTH] backend returned a different user id; aborting');
                this.authenticationService.logout();
                this.showNotification('error', 'Session integrity error, please sign in again');
                this.router.navigate([''], {queryParamsHandling: 'preserve'});
                return;
              }
              if (data.orgSettings) {
                preReauthUser.orgSettings = data.orgSettings;
              }
              this.currentUser = preReauthUser;
              this.selectedRole = this.currentUser.role?.[0] || this.currentUser.selectedRole;
              this.persistNativeSession(this.currentUser);
              this.routeToProperComponent();
            } else {
              // Only adopt a payload that is actually an identity. A
              // half-provisioned merchant used to come back as the minimal
              // re-auth shape ({ok, orgSettings, merchantId}) with a null
              // orgSettings; adopting that made currentUser.orgSettings null
              // and every template binding on orgSettings.accountType threw,
              // leaving a blank page with no way out. Send them to sign-in
              // with a message instead.
              if (!data.token || !data._id || !data.orgSettings) {
                console.error('[CLOVER AUTH] incomplete login payload; refusing to adopt as session');
                this.showNotification('error', 'This Clover account is not fully set up yet. Please sign in with your DineNGo credentials.');
                this.router.navigate([''], {queryParamsHandling: 'preserve'});
                return;
              }
              // First-time auth path: adopt the full response as the new user.
              // This keeps the original "Sign in with Clover" landing button
              // behavior intact — backend mints a JWT, FE drops it into
              // localStorage (via authentication.service.cloverLogin) and we
              // route by the returned role.
              this.currentUser = data;
              this.selectedRole = this.currentUser.role?.[0];
              this.persistNativeSession(this.currentUser);
              this.routeToProperComponent();
            }
          },
          error => {
            console.error(error);
            if (this.currentUser && this.currentUser.token) {
              // Re-auth flow: user is already logged in, just route them back
              this.routeToProperComponent();
            } else {
              this.showNotification('error', error);
              this.router.navigate([''], {queryParamsHandling: 'preserve'});
            }
          });
  }

  private persistNativeSession(user: User): void {
    if (!Capacitor.isNativePlatform() || !user) { return; }
    const encrypted = this._AESEncryptDecryptService.encrypt(JSON.stringify(user));
    Promise.all([
      Preferences.set({key: 'user', value: encrypted}),
      Preferences.set({key: 'currentUser', value: encrypted}),
    ]).catch(() => { /* localStorage remains the fallback for this session */ });
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  scanToPayRouter(orderId, oldUser) {
    return this.router.navigate(['/payment-kiosk/paymentScreen',
        {
          tableUuid: oldUser.firstName ? oldUser.firstName : oldUser.username,
          tableName: oldUser.firstName ? oldUser.firstName : oldUser.username,
          orderId: orderId,
          scanToPay: true,
          lineItemStatus: 'CreditCardPay',
          disablePrint: true
        }]);
  }

  scanToJukeboxPay(playList, user) {
    return this.router.navigate(['/payment-kiosk/paymentScreen',
        {
          tableUuid: user.firstName ? user.firstName : user.username,
          tableName: user.firstName ? user.firstName : user.username,
          playlist: playList,
          scanToPay: true,
          lineItemStatus: 'CreditCardPay',
          disablePrint: true
        }]);
  }

  private routeToProperComponent() {
    if (this.currentUser.role.length > 1) {
      this.router.navigate(['/select-role']);
    } else if ((this.selectedRole === 'Admin'  && !this.currentUser.dashboardDisabled)) {
      this.router.navigate(['/select-role']); ///sidebar/admin/dashboard
    } else if (this.selectedRole === 'Manager' || this.selectedRole === 'Server' || this.currentUser.dashboardDisabled) {
      this.router.navigate(['/sidebar/cashier']).then(() => {
        // window.location.reload();
      });
    } else if (this.selectedRole === 'Table') {
      this.router.navigate(['/sidebar/order']).then(() => {
        // window.location.reload();
      });
    } else if (this.selectedRole === 'Rewards') {
      this.router.navigate(['/rewards'])
          .then(() => {
            // window.location.reload();
          });
    } else if (this.selectedRole === 'PaymentsDisplay') {
      this.router.navigate(['/paymentUser/paymentUser']).then(() => {
        // window.location.reload();
      });
    } else if (this.selectedRole === 'OrdersDisplay') {
      this.router.navigate(['/orderUser/orderUser']).then(() => {
        window.location.reload();
      });
    } else if (this.selectedRole === 'Kiosk') {
      this.router.navigate(['/kiosk']).then(() => {
        // window.location.reload();
      });
    } else if (this.selectedRole === 'QROrder') {
      this.router.navigate(['/QROrder']).then(() => {
        // window.location.reload();
      });
    } else {
      this.router.navigate(['/home'], {queryParamsHandling: 'preserve'}).then(() => {
        // window.location.reload();
      });
    }
  }

  deleteQueryParameterFromCurrentRoute() {
    // this.location.replaceState('./order');
    this.location.replaceState(window.location.href.split('?')[0].split(window.location.href.split('/')[2])[1]);
  }
}
